import * as React from 'react';
import Icon from '../Icon/Icon';
import BaseList from '../BaseList/BaseList';

interface Props {
  items: Array<any>;
  showEmail?: boolean;
  showJoinDate?: boolean;
  handleClick?: any;
  hideSearch?: boolean;
  renderBody?: any;
  noAnimation?: boolean;
  renderHead?: Function;
}

class AccessoryList extends BaseList<Props> {
  constructor(props) {
    super(props, {
      fields: BaseList.fields.accessories.search,
      search: BaseList.search.accessories,
      path: 'settings/accessories',
      name: 'accessories',
    });
  }

  renderHead(accessory: any) {
    if (this.props.renderHead) {
      return this.props.renderHead(accessory);
    }
    return (
      <strong>
        <span>{accessory.name}</span>
        {accessory.featured && (
          <span className="has-text-primary">
            <Icon icon="star" />
          </span>
        )}
      </strong>
    );
  }

  renderLeft(item) {
    if (!item || !item.image) {
      return null;
    }
    return (
      <span className="avatar image is-64x64">
        <img src={item.image} alt={item.name} />
      </span>
    );
  }
}

export default AccessoryList;
